module.exports = __webpack_public_path__ + "static/media/logo-ema.d1da05f0.mp4";